import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";

import { ReportProvider } from "./context/ReportContext";
import LoginPage from "./components/LoginPage";
import PowerBIEmbed from "./components/PowerBIEmbed";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./components/HomePage";
import PageLayout from "./components/PageLayout";
import defaultReport from "./config/defaultReport";

function App() {
  const defaultPath = `/${encodeURIComponent(defaultReport.dashboard)}/${encodeURIComponent(defaultReport.report)}/${encodeURIComponent(defaultReport.page)}`;

  return (
    <MsalProvider instance={msalInstance}>
      <ReportProvider>
        <Router>
          <Routes>
            {/* Public login */}
            <Route path="/login" element={<LoginPage />} />

            {/* Home redirects to default report */}
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <PageLayout>
                    <HomePage />
                  </PageLayout>
                </ProtectedRoute>
              }
            />

            {/* Legacy URL */}
            <Route path="/advance-metering" element={<Navigate to={defaultPath} replace />} />

            {/* Embed pages */}
            <Route
              path="/:dashboard/:report/:page"
              element={
                <ProtectedRoute>
                  <PageLayout>
                    <PowerBIEmbed />
                  </PageLayout>
                </ProtectedRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </ReportProvider>
    </MsalProvider>
  );
}

export default App;
